import { render, staticRenderFns } from "./pwa_images.vue?vue&type=template&id=61310819&scoped=true&"
import script from "./pwa_images.vue?vue&type=script&lang=js&"
export * from "./pwa_images.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61310819",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61310819')) {
      api.createRecord('61310819', component.options)
    } else {
      api.reload('61310819', component.options)
    }
    module.hot.accept("./pwa_images.vue?vue&type=template&id=61310819&scoped=true&", function () {
      api.rerender('61310819', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/aggregators/pwa/settings/tabs/pwa_images.vue"
export default component.exports